export const STEP = Object.freeze({
  IDLE: 'idle',
  UPLOADING: 'uploading',
  OPTIONS: 'options',
  PREVIEW: 'preview',
  RESULT: 'result'
})

export const FILE_FORMATS = Object.freeze({
  CERTIFICATES: '.cer, .crt, .p7b, .pem'
})
